
import React, {useState} from 'react'
import { Link } from 'react-router-dom'
type Props = {
  notFoundTitle?:string,
  notFoundText?:string,
  homeButtonText?:string,
  homeButtonLink?:string,
}


const NotFound: React.FC<Props> = ({ notFoundTitle, notFoundText, homeButtonText="Return Home", homeButtonLink="/" }) => {

  return (
    <div className='d-flex flex-column flex-center text-center h-100'>
        <div className='card card-flush  w-lg-650px py-5'>
            <div className="card-body py-15 py-lg-20">
                <h1 className="fw-bolder fs-2hx text-gray-900 mb-4">{notFoundTitle || "Oops!"}</h1>
                <div className="fw-semibold fs-6 text-gray-500 mb-7">{notFoundText || "We can't find that page."}</div>
                <div className="mb-3">
                    <i className="ki-filled ki-information-1 fs-10"></i>
                </div>
                <div className="mb-0">
                    <Link className="btn btn-sm btn-primary" to={homeButtonLink} data-discover="true">{homeButtonText}</Link>
                </div>
            </div>
        </div>
    </div>
  )
}
export default NotFound